export default {"src":"/_next/static/media/frontend_roadmap.37f4192d.svg","height":314,"width":696,"blurWidth":0,"blurHeight":0};